module.exports = {
  mainJs: '/dist/main.js',
  mainCss: '/dist/main.css',
}
